import React from 'react';
import styles from './AttachmentsList.module.scss';
import { useSetTsAttachments, useTsAttachments } from '../../model';
import { Icon } from 'antd';

const Attachment = ({ attach, index }) => {
  const { removeFile } = useSetTsAttachments();

  return (
    <div className={styles.attachment}>
      <div className={styles.leftBlock}>
        <Icon type="file" />
        <span>{attach.file.name}</span>
      </div>
      <Icon
        type="delete"
        onClick={() => removeFile(index)}
        style={{ color: 'red' }}
      />
    </div>
  );
};

const AttachmentsList = () => {
  const data = useTsAttachments();

  return (
    <ul className={styles.root}>
      {data.map((attach, index) => (
        <li key={index}>
          <Attachment attach={attach} index={index} />
        </li>
      ))}
    </ul>
  );
};

export default AttachmentsList;
